import React from "react";
import {
  companyDisplayName,
  isUnnamedCompany,
} from "utilities/companyName";

/**
 * SOUND-630 — a company's name, or an italicised "New Merchant" placeholder.
 *
 * A blank cell reads as a broken record. These are not broken: every one is a
 * real self-serve signup with a working login and a pending application, which
 * simply has not reached the business-name field yet.
 *
 * Italic is doing real work here — it is what separates a placeholder from a
 * merchant who literally named their business "New Merchant". Do not swap it for
 * plain text.
 */
export default function CompanyName({ company, className = "" }) {
  const unnamed = isUnnamedCompany(company);
  const label = companyDisplayName(company);

  return (
    <span
      className={`${unnamed ? "italic text-muted-foreground" : ""} ${className}`.trim()}
      // The plain string, so a hover reveals the same thing a screen reader and
      // an export would see.
      title={label}
    >
      {label}
    </span>
  );
}
